import React from "react";
import { Helmet } from "react-helmet-async";

interface SeoHeadProps {
  title: string;
  description: string;
  canonicalPath: string; // e.g. "/" or "/ar"
  locale: "en" | "ar";
}

export const SeoHead: React.FC<SeoHeadProps> = ({ title, description, canonicalPath, locale }) => {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const canonicalUrl = `${origin}${canonicalPath}`;
  const hrefEn = `${origin}/`;
  const hrefAr = `${origin}/ar`;
  const ogLocale = locale === "ar" ? "ar_SA" : "en_US";
  const twitterImage = "/lovable-uploads/127f04fd-2248-42ef-acdb-a7f9cd61e264.png";
  const ogImage = twitterImage;

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "Shohnat",
    url: canonicalUrl,
    inLanguage: locale,
    description,
  };

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Hreflang alternates */}
      <link rel="alternate" hrefLang="en" href={hrefEn} />
      <link rel="alternate" hrefLang="ar" href={hrefAr} />
      <link rel="alternate" hrefLang="x-default" href={hrefEn} />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:locale" content={ogLocale} />
      <meta property="og:locale:alternate" content={locale === "ar" ? "en_US" : "ar_SA"} />
      <meta property="og:image" content={ogImage} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={twitterImage} />

      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(jsonLd)}
      </script>
    </Helmet>
  );
};

export default SeoHead;
